import styled from 'styled-components';

const AccueilStyled = styled.div`

  @keyframes bounce {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0);
    }
  }

  display: block;
  min-height: 100vh;
    
    .top-wrapper {
        width: 100vw;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${props => props.windowTop ? props.bcgColor === '#fff' ? '#fff' : '' : '#fff'};

        .btn-connexion {
            font-size: 16px;
            color: #fff;
            background-color: #6399ce;
            border-radius: 5px;
            padding: 8px 15px;
            width: 150px;
            text-align: center;
            
            svg {
                font-size: 14px;
                margin-right: 5px;
            }
        }

        .btn-logout {
            font-size: 16px;
            color: #fff;
            background-color: #dc4a46;
            border-radius: 5px;
            padding: 8px 15px;
            width: 150px;
            text-align: center;
            
            svg {
                font-size: 16px;
                margin: 0 5px -3px 0;
            }
        }

        img {
            margin-left: 15px;
            max-width: 100px;
            height: auto;
        }
    }

    .burger-icon {
      font-size: 40px;
      color: #202c3c;
      cursor: pointer;
      margin: 10px 10px 0 0;
      transition: transform 0.5s ease-in-out;
    }

    .burger-list {

      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      transition: transform 0.5s ease-in-out;
      height: 100%;
      min-height: 100vh;

      .hd-top {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        position: relative;

        padding: 10px 10px 30px 10px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
        background: linear-gradient(51deg, #eaeef9 0%, #d5def2 30%, #8bbee2 100%);
        clip-path: polygon(100% 0%, 0% 0% , 0.00% 90.00%, 0.67% 89.50%, 1.33% 89.00%, 2.00% 88.50%, 2.67% 88.00%, 3.33% 87.51%, 4.00% 87.03%, 4.67% 86.55%, 5.33% 86.09%, 6.00% 85.63%, 6.67% 85.18%, 7.33% 84.75%, 8.00% 84.33%, 8.67% 83.92%, 9.33% 83.53%, 10.00% 83.15%, 10.67% 82.80%, 11.33% 82.46%, 12.00% 82.14%, 12.67% 81.84%, 13.33% 81.56%, 14.00% 81.30%, 14.67% 81.06%, 15.33% 80.85%, 16.00% 80.66%, 16.67% 80.49%, 17.33% 80.35%, 18.00% 80.23%, 18.67% 80.13%, 19.33% 80.06%, 20.00% 80.02%, 20.67% 80.00%, 21.33% 80.01%, 22.00% 80.04%, 22.67% 80.10%, 23.33% 80.18%, 24.00% 80.28%, 24.67% 80.41%, 25.33% 80.57%, 26.00% 80.75%, 26.67% 80.95%, 27.33% 81.18%, 28.00% 81.42%, 28.67% 81.69%, 29.33% 81.98%, 30.00% 82.29%, 30.67% 82.62%, 31.33% 82.97%, 32.00% 83.34%, 32.67% 83.72%, 33.33% 84.12%, 34.00% 84.54%, 34.67% 84.96%, 35.33% 85.40%, 36.00% 85.86%, 36.67% 86.32%, 37.33% 86.79%, 38.00% 87.27%, 38.67% 87.76%, 39.33% 88.25%, 40.00% 88.75%, 40.67% 89.25%, 41.33% 89.75%, 42.00% 90.25%, 42.67% 90.75%, 43.33% 91.25%, 44.00% 91.75%, 44.67% 92.24%, 45.33% 92.73%, 46.00% 93.21%, 46.67% 93.68%, 47.33% 94.14%, 48.00% 94.60%, 48.67% 95.04%, 49.33% 95.46%, 50.00% 95.88%, 50.67% 96.28%, 51.33% 96.66%, 52.00% 97.03%, 52.67% 97.38%, 53.33% 97.71%, 54.00% 98.02%, 54.67% 98.31%, 55.33% 98.58%, 56.00% 98.82%, 56.67% 99.05%, 57.33% 99.25%, 58.00% 99.43%, 58.67% 99.59%, 59.33% 99.72%, 60.00% 99.82%, 60.67% 99.90%, 61.33% 99.96%, 62.00% 99.99%, 62.67% 100.00%, 63.33% 99.98%, 64.00% 99.94%, 64.67% 99.87%, 65.33% 99.77%, 66.00% 99.65%, 66.67% 99.51%, 67.33% 99.34%, 68.00% 99.15%, 68.67% 98.94%, 69.33% 98.70%, 70.00% 98.44%, 70.67% 98.16%, 71.33% 97.86%, 72.00% 97.54%, 72.67% 97.20%, 73.33% 96.85%, 74.00% 96.47%, 74.67% 96.08%, 75.33% 95.67%, 76.00% 95.25%, 76.67% 94.82%, 77.33% 94.37%, 78.00% 93.91%, 78.67% 93.45%, 79.33% 92.97%, 80.00% 92.49%, 80.67% 92.00%, 81.33% 91.50%, 82.00% 91.00%, 82.67% 90.50%, 83.33% 90.00%, 84.00% 89.50%, 84.67% 89.00%, 85.33% 88.50%, 86.00% 88.00%, 86.67% 87.51%, 87.33% 87.03%, 88.00% 86.55%, 88.67% 86.09%, 89.33% 85.63%, 90.00% 85.18%, 90.67% 84.75%, 91.33% 84.33%, 92.00% 83.92%, 92.67% 83.53%, 93.33% 83.15%, 94.00% 82.80%, 94.67% 82.46%, 95.33% 82.14%, 96.00% 81.84%, 96.67% 81.56%, 97.33% 81.30%, 98.00% 81.06%, 98.67% 80.85%, 99.33% 80.66%, 100.00% 80.49%);

        div {
          display: flex;
          flex-wrap: wrap;

          h2 {
            margin-top: 8px;
            font-size: 14px;
            background: -webkit-linear-gradient(180deg, #2d74b8, #769ed3, #2d74b8);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .logo-qualiopi {
            height: 30px;
            margin: 10px 0 0 10px;
          }
        }

        .logo-wefor {
          width: 50px;
        }
      }

      .logo-homme {
        width: 70px;
        margin: 0 auto;
        position: absolute;
        left: calc(50%  - 35px);
        top: 40px;
        z-index: 2;
      }

      .link-orange {
        color: #D47558;
        margin-top: 20px;

        svg {
          margin-bottom: -2px;
        }
      }

      .wrapper-menus {
        width: 100%;
      }

      .title-list {
        width: 100%;
        font-size: 20px;
        padding: 20px 0;
        text-align: center;
        background-color: #fff;
        color: #202c3c;

        &.border-bottom {
          border-bottom: 1px solid #202c3c;
        }

        &.borders {
          border-bottom: 1px solid #202c3c;
          border-top: 1px solid #202c3c;
        }
      }

      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 40px;
        color: #202c3c;
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #fff;
      }

      .burger-nav {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
        padding: 0;
        list-style: none;
        width: 100%;

        .title-list {
          background-color: #202c3c;
          color: #fff;
        }

        .nav-item {
            margin: 0 auto;
            width: 90%;
            max-width: 600px;
        }

        .nav-link {
            font-size: 16px;
            width: 100%;
            height: 100%;
            padding: 15px 0 15px 0px;
            font-weight: 700;
            display: flex;
            justify-content: center;
            align-items: center;
            text-decoration: none;
            transition: color 0.3s ease-in-out;
            margin: 0 0 20px 0;

            a {
              width: 100%;

              span {
                width: 100%;
              }
            }
            &.formation-link {
              color: #d47558;
              border: 1px solid #d47558;
              background-color: #f8e8e3;
              position: relative;
              border-radius: 20px;
            }

            &.job-link {
              color: #6aaf8b;
              border: 1px solid #6aaf8b;
              background-color: #e1efe7;
              position: relative;
              border-radius: 20px;
            }

            &.financement-link {
              border: 1px solid #6399ce;
              background-color: #dbe8f4;
              border-radius: 20px;
              color: #6399ce;
            }

            &.wefor-link {
              border: 1px solid #D071AB;
              background-color: #F6ECF3;
              border-radius: 20px;
              color: #D071AB;
            }
        }
      }

      .empty-div {
        width: 100%;

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          align-items: stretch;
          justify-content: space-evenly;
          margin: 20px 0 20px 0;
        }
        

        .nav-link {
          font-size: 17px;
          height: 100%;
          width: 32%;
          max-width: 250px;
          padding: 15px 5px 15px 5px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-decoration: none;
          transition: color 0.3s ease-in-out;
          color: #202c3c;
          text-align: center;
          border: 2px solid #202c3c;
          border-radius: 5px;
          min-height: 70px;
          cursor: pointer;

          &:nth-child(2) {
            background-color: #ECF3EF;
            color: #6AAF8B;
            border: 1px solid #6AAF8B;

            &.active {
              color: #fff;
              background-color: #6AAF8B;
  
            }
          }
          &:nth-child(1) {
            background-color: #F7EDEA;
            color: #D47558;
            border: 1px solid #D47558;

            &.active {
              color: #fff;
              background-color: #D47558;
  
            }
          }
          &:nth-child(3) {
            background-color: #dbe8f4;
            color: #649ACE;
            border: 1px solid #649ACE;

            &.active {
              color: #fff;
              background-color: #649ACE;
  
            }
          }

          svg {
              font-size: 24px;
              color: #39a5d6;
          }

          span {
            width: 100%;
          }

          &.active {
            color: #fff;
            background-color: #202c3c;

          }
        }


        .choose-statut { 
          text-align: center;
          margin-top: 20px;
          font-size: 26px;
          color: #39a5d6;

          .bounce-item {
            animation-name: bounce;
            animation-duration: 1s;
            animation-fill-mode: both;
            animation-iteration-count: infinite;
          }

          svg {
            font-size: 26px;
          }
        }
      }

      .access-dashbord {
        background-color: #39a5d6;
        padding: 15px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 20px;
        color: #fff;
      }

      .bottom-nav {
        display: flex;
        justify-content: space-evenly;
        padding: 10px 0;
        width: 100%;
        background-color: #dbe8f4;
        border: 1px solid #649ACE;
        border-radius: 20px 20px 0 0;
        border-bottom: 0;
        margin: 20px 0 0 0;

        .link-item {
          font-size: 22px;
          text-decoration: none;
          transition: color 0.3s ease-in-out;
          color: #2b6187;

          &:hover {
            color: #d11a2a;
          }
        }
      }
    }

  @media (max-width: 759px) {
    display: block;
    
    .top-wrapper {
        width: 100vw;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${props => props.windowTop ? props.bcgColor === '#fff' ? '#fff' : '' : '#fff'};

        .btn-connexion {
            font-size: 16px;
            color: #fff;
            background-color: #6399ce;
            border-radius: 5px;
            padding: 8px 15px;
            width: 150px;
            text-align: center;
            
            svg {
                font-size: 14px;
                margin-right: 5px;
            }
        }

        .btn-logout {
            font-size: 16px;
            color: #fff;
            background-color: #dc4a46;
            border-radius: 5px;
            padding: 8px 15px;
            width: 150px;
            text-align: center;
            
            svg {
                font-size: 16px;
                margin: 0 5px -3px 0;
            }
        }

        img {
            margin-left: 15px;
            max-width: 100px;
            height: auto;
        }
    }

    .burger-icon {
      font-size: 40px;
      color: #202c3c;
      cursor: pointer;
      margin: 10px 10px 0 0;
      transition: transform 0.5s ease-in-out;
    }

    .burger-list {

      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      transition: transform 0.5s ease-in-out;
      min-height: 100vh;
      height: 100%;

      .wrapper-menus {
        width: 100%;
      }

      .title-list {
        width: 100%;
        font-size: 20px;
        padding: 20px 0;
        text-align: center;
        background-color: #fff;
        color: #202c3c;

        &.border-bottom {
          border-bottom: 1px solid #202c3c;
        }

        &.borders {
          border-bottom: 1px solid #202c3c;
          border-top: 1px solid #202c3c;
        }
      }

      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 40px;
        color: #202c3c;
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #fff;
      }

      .empty-div {
        width: 100%;

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          align-items: stretch;
          justify-content: space-evenly;
          margin: 20px 0 20px 0;
        }
        

        .nav-link {
          font-size: 15px;
          height: 100%;
          width: 100px;
          padding: 5px 5px 5px 5px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-decoration: none;
          transition: color 0.3s ease-in-out;
          color: #202c3c;
          text-align: center;
          border: 2px solid #202c3c;
          border-radius: 10px;
          min-height: 50px;
          cursor: pointer;

          svg {
              font-size: 24px;
              color: #39a5d6;
          }

          span {
            width: 100%;
          }

          &.active {
            color: #fff;
            background-color: #202c3c;

          }
        }


        .choose-statut { 
          text-align: center;
          margin-top: 20px;
          font-size: 20px;
          color: #39a5d6;

          .bounce-item {
            animation-name: bounce;
            animation-duration: 1s;
            animation-fill-mode: both;
            animation-iteration-count: infinite;
          }

          svg {
            font-size: 20px;
          }
        }
      }

      .access-dashbord {
        background-color: #39a5d6;
        padding: 15px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 20px;
        color: #fff;
      }

      .bottom-nav {
        display: flex;
        justify-content: space-evenly;
        padding: 10px 0;
        width: 100%;

        .link-item {
          font-size: 22px;
          text-decoration: none;
          transition: color 0.3s ease-in-out;
          color: #2b6187;

          &:hover {
            color: #d11a2a;
          }
        }
      }
    }
  }
`;

export default AccueilStyled;